import { useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { useDispatch, useSelector } from 'react-redux'
import useFormStatus from '@/containers/SubscriptionFormPageNew/SubscriptionForm/useFormStatus'
import { subscriptionFormActionsV2 } from '@/containers/SubscriptionFormPageNew/SubscriptionForm/SubscriptionFormV2Sagas'
import { selectClientConfig } from '../../SubscriptionForm/SubscriptionFormSelectors'
import {
  selectConfig,
  selectPersonalClientSubscriptionData,
} from '@/containers/SubscriptionFormPageNew/SubscriptionForm/SubscriptionFormSelectors'
import { useSnackbar } from 'baseui/snackbar'

const useZoho = () => {
  const { t } = useTranslation()
  const dispatch = useDispatch()
  const { zohoId } = useSelector(selectPersonalClientSubscriptionData)
  const { isMcpClient, isValidZohoId, isMcpLocked } = useSelector(selectClientConfig)
  const { isImportingContactFromZoho } = useSelector(selectConfig)
  const { formIsLoaded } = useFormStatus()
  const { enqueue } = useSnackbar()

  const importZohoClientData = () => {
    dispatch({
      type: subscriptionFormActionsV2.CUSTOMER_DATA_IMPORT_ZOHO_CLIENT_V2,
      contactId: zohoId,
      enqueue,
    })
  }
  const validateZohoId = () => {
    dispatch({
      type: subscriptionFormActionsV2.ZOHO_MODULE_VERIFY_ID_V2,
      zohoId,
    })
  }

  useEffect(() => {
    if (!zohoId) return
    validateZohoId()
  }, [zohoId])

  return {
    formIsLoaded,
    t,
    zohoId,
    isMcpClient,
    isValidZohoId,
    isMcpLocked,
    importZohoClientData,
    isImporting: isImportingContactFromZoho,
  }
}

export default useZoho
